import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/_services/auth.guard';
import { WebshopViewComponent } from './modules/webshop/webshops/webshop-view/webshop-view.component';
import { WebshopHomeComponent } from './modules/webshop/webshops/webshophome/webshophome.component';
import { WebshopAccountComponent } from './modules/webshop/webshops/account/account.component';
// import { LayoutComponent } from './pages/_layout/layout.component';

export const routes: Routes = [
  // {
  //   path: 'auth',
  //   loadChildren: () =>
  //     import('./modules/auth/auth.module').then((m) => m.AuthModule),
  // },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  
  {
    path:'',
    //component: WebshopHomeComponent
    component: WebshopViewComponent,
}, //test eric
{
    path: 'articles',
    component: WebshopViewComponent,
},
{
    path: 'account',
    component: WebshopAccountComponent,
},
  // {
  //   path: '',
  //   component: LayoutComponent,
    
  //     // loadChildren: () =>
  //     // import('./pages/layout.module').then((m) => m.LayoutModule),

  //   // **************************************************************************************
  //   // TODO: ACTIVATE ON DEPLOYMENT
  //   // **************************************************************************************
  //   // canActivate: [AuthGuard],

  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./pages/layout.module').then((m) => m.LayoutModule),
  //     },
  //     {
  //       path: 'kunden',
  //       loadChildren: () => import('./modules/kunden/kunden.module').then(m => m.KundenModule),
  //     },
  //     {
  //       path: 'webshop',
  //       loadChildren: () => import('./modules/webshop/webshop.module').then(m => m.WebshopModule),
  //     },
  //   ],
  // },
  { 
    path: '**', 
    redirectTo: 'error/404' 
  },
];

@NgModule({
  //imports: [RouterModule.forRoot(routes)], //Eric
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
